/**
 * The add dialog's "site on our platform" field (item K).
 *
 * One list of the platform sites nobody watches yet, with "not a platform
 * site" on top, which is what every outside site (WordPress and the rest)
 * stays on. Picking a site hands the dialog the site itself; the dialog then
 * takes the address from the site's own verified domains instead of a typed
 * one, so the monitor can never show one site's inside view under another
 * site's address (the server refuses that too).
 *
 * Not drawn when the list is empty or could not be read: the dialog is then
 * exactly what it was before platform sites existed.
 */
import type { PlatformSiteOption } from "../../../../lib/monitoringPlatform";
import { SelectInput } from "../../../ui";
import { Field } from "../../_shared/formBits";
import type { T } from "../words";

export function PlatformSiteField({
  sites,
  value,
  onPick,
  t,
}: {
  /** The sites nobody watches yet. */
  sites: readonly PlatformSiteOption[];
  /** The picked site's id, or "" for none. */
  value: string;
  onPick: (site: PlatformSiteOption | null) => void;
  t: T;
}) {
  if (sites.length === 0) return null;
  return (
    <Field label={t("monitoring.platform.field.label")} hint={t("monitoring.platform.field.hint")}>
      <SelectInput
        value={value}
        onChange={(id) => onPick(sites.find((s) => s.siteId === id) ?? null)}
        label={t("monitoring.platform.field.label")}
      >
        <option value="">{t("monitoring.platform.field.none")}</option>
        {sites.map((s) => (
          <option key={s.siteId} value={s.siteId}>
            {`${s.name} · ${s.host}`}
          </option>
        ))}
      </SelectInput>
    </Field>
  );
}
